<template>
  <div class="section section-white">
    <el-form ref="form" :model="form" class="box-set" label-width="120px">
      <div class="section-header with-border">
        <div>添加/编辑满赠促销</div>
      </div>
      <div class="form-wrapper clearfix">
          <el-form-item label="名称" prop="marketing_name" :rules="{required: true, message: '活动名称必填', trigger: 'blur'}">
            <el-col :span="20">
              <el-input v-model="form.marketing_name" :maxlength=30 placeholder="最多30个字"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="绑定商品">
              <el-radio v-model="form.use_bound" :label="0">全场可用</el-radio>
              <el-radio v-model="form.use_bound" :label="1">指定商品可用</el-radio>
            <el-col :span="23" v-if="form.use_bound == 1">
              <el-button type="primary" class="el-icon-plus" @click="relItemsClick" size="mini" round>选商品</el-button>
              <el-table v-if="relItems.length>0" :data="relItems" style="line-height: normal">
                <el-table-column label="ID" prop="itemId" width="60"></el-table-column>
                <el-table-column label="名称" prop="itemName"></el-table-column>
                <el-table-column label="价格" prop="price" width="100">
                  <template slot-scope="scope">
                    {{scope.row.price/100}}
                  </template>
                </el-table-column>
                <el-table-column label="库存" prop="store" width="90"></el-table-column>
                <el-table-column label="操作" width="50">
                  <template slot-scope="scope">
                    <i class="iconfont icon-trash-alt" @click="deleteItemRow(scope.$index, form.items)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-form-item>
          <el-form-item label="指定店铺">
              <el-radio v-model="form.use_shop" :label="0">全场可用</el-radio>
              <el-radio v-model="form.use_shop" :label="1">指定店铺可用</el-radio>
            <el-col :span="23" v-if="form.use_shop == 1">
              <el-button type="primary" class="el-icon-plus" @click="relStoresClick" size="mini" round>选店铺</el-button>
              <el-table v-if="relStores.length > 0" :data="relStores" style="line-height: normal">
                <el-table-column label="ID" prop="distributor_id" width="60"></el-table-column>
                <el-table-column label="名称" prop="name"></el-table-column>
                <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="50">
                  <template slot-scope="scope">
                    <i class="iconfont icon-trash-alt" @click="deleteStoreRow(scope.$index, form.items)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-form-item>
          <el-form-item label="促销规则">
            <el-row :gutter="1">
              <el-col :span="7">
                <el-radio v-model="form.condition_type" label="quantity">按订单总件数</el-radio>
                <el-radio v-model="form.condition_type" label="totalfee">按订单总金额</el-radio>
              </el-col>
              <el-col :span="6">
                  <span v-if="form.condition_type == 'totalfee'" v-for="(item,key) in conditionValue" :key="key">消费满 <el-input type="input" v-model="item.full" placeholder="0.00" style="width:100px" size="mini"></el-input> 元，加价购</span>
                  <span v-if="form.condition_type == 'quantity'" v-for="(item,key) in conditionValue" :key="key">消费满 <el-input type="input" v-model="item.full" placeholder="0.00" style="width:100px" size="mini"></el-input> 件，加价购</span>
              </el-col>
            </el-row>
            <div>
              <el-button type="primary" @click="addRules()" size="mini">新增加价区间</el-button>
              <div v-for="(item,key) in purchaseRules" :key="key" >
                <el-row>
                  <el-col :span="5">
                    加价购金额：<el-input v-model="item.price" style="width:100px" size="mini"></el-input>
                  </el-col>
                  <el-col :span="15">
                    <el-button type="primary" class="el-icon-plus" @click="relGiftsClick(key, item.gift_item)" size="mini" round>选商品</el-button>
                    <el-table :data="item.gift_item" style="line-height: normal" width="20%">
                      <el-table-column label="ID" prop="itemId" width="60"></el-table-column>
                      <el-table-column label="名称" prop="itemName"></el-table-column>
                      <el-table-column label="赠品数量" width="100">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.gift_num" width="90" size="mini"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                          <i class="iconfont icon-trash-alt" @click="deleteGiftRow(key, scope.$index)"></i>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-col>
                  <el-col :span="2">
                    <el-button v-if="key == 0" type="info" icon="el-icon-delete" circle></el-button>
                    <el-button v-else type="danger" icon="el-icon-delete" circle @click="delRules(key)"></el-button>
                  </el-col>
                </el-row>
                <div></div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="规则描述">
            <el-col :span="20">
              <el-input type="textarea" :rows="3" v-model="form.marketing_desc" placeholder="规则描述"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="可参与次数">
            <el-col :span="20">
              <el-input type="input" v-model="form.join_limit" placeholder="整数数字"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="适用会员">
            <el-checkbox-group v-model="validGrade">
              <el-checkbox v-for="grade in memberGrade" :label="grade.grade_id" :key="grade.grade_id">{{grade.grade_name}}</el-checkbox>
              <el-checkbox v-for="vipdata in vipGrade" :label="vipdata.lv_type" :key="vipdata.vip_grade_id">付费{{vipdata.grade_name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="适用平台">
            <el-radio-group v-model="form.used_platform">
              <el-radio :label="0">全场可用</el-radio>
              <el-radio :label="1">只用于pc端</el-radio>
              <el-radio :label="2">只用于小程序端</el-radio>
              <el-radio :label="3">只用于h5端</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="有效期">
            <el-col :span="20">
              <el-date-picker
                v-model="activity_date"
                type="datetimerange"
                range-separator="至"
                start-placeholder="生效时间"
                end-placeholder="过期时间"
                format="yyyy/MM/dd HH:mm:ss"
                value-format="timestamp"
                :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label=" ">
            <el-button type="primary" @click="submitActivityAction()">保存</el-button>
            <el-button @click.native="handleCancel">返回</el-button>
          </el-form-item>
      </div>
    </el-form>
    <GoodsSelect :items-visible="itemVisible" :get-status="setItemStatus" :rel-items-ids="relItems" :item-type="form.item_type" @chooseStore="chooseItemsAction" @closeStoreDialog="closeItemDialogAction"></GoodsSelect>
    <GoodsSelect :items-visible="giftVisible" :get-status="setGiftStatus" :get-params="getParams" :rel-items-ids="relGiftIds" :item-type="form.item_type" @chooseStore="chooseGiftsAction" @closeStoreDialog="closeGiftsDialogAction"></GoodsSelect>
    <StoreSelect :store-visible="storeVisible" :is-valid="true" :rel-shop-ids="relStores" :get-status="setStatus" @chooseStore="chooseStoreAction" @closeStoreDialog="closeStoreDialogAction"></StoreSelect>
  </div>
</template>

<script>
import { addMarketingActivity, updateMarketingActivity, getMarketingActivityInfo } from '../../../../api/promotions'
import { getGradeList } from '../../../../api/membercard'
import { listVipGrade } from '../../../../api/cardticket'
import { getDefaultCurrency } from '../../../../api/company'
import StoreSelect from '@/components/storeListSelect'
import GoodsSelect from '@/components/goodsSelect'
export default {
  inject: ['refresh'],
  components:{
    GoodsSelect,
    StoreSelect,
  },
  data () {
    return {
      cursymbol: '￥',
      storeVisible: false,
      relItems: [],
      relStores: [],
      setStatus: false,
      form: {
        marketing_id: '',
        marketing_type: 'plus_price_buy',
        marketing_name: '',
        marketing_desc: '',
        start_time: '',
        end_time: '',
        used_platform: 0,
        use_bound: 0,
        use_shop: 0,
        shop_ids: [],
        item_ids: [],
        item_type: 'normal',
        valid_grade: [],
        condition_type: 'totalfee',
        condition_value: [],
        join_limit: 0,
        promotion_tag: '加价购',
        canjoin_repeat: false,
      },
      vipGrade: [],
      memberGrade: [],
      validGrade: [],
      activity_date: '',
      selectItemType: 'normal',
      itemVisible: false,
      setItemStatus: false,
      imgDialog: false,
      isGetImage: false,
      isIndeterminate: true,
      checkAll: false,
      relGifts: [],
      relGiftIds: [],
      giftVisible: false,
      purchaseRules: [
        {price: '', gift_item:[]}
      ],
      conditionValue: [
        {full:''},
      ],
      setGiftStatus: false,
      ruleKey: 0,
      getParams: {
        price:0
      }
    }
  },
  watch: {
    relItems(val) {
      this.form.use_shop = val.length > 0 ? 1 : 0
    },
    relStores(val) {
      this.form.use_bound = val.length > 0 ? 1 : 0
    }
  },
  methods:{
    addRules () {
      var rule = {price: '', gift_item:[]}
      this.purchaseRules.push(rule)
    },
    delRules(index){
      this.purchaseRules.splice(index,1)
    },
    relItemsClick () {
      this.itemVisible = true
      this.setItemStatus = true
    },
    chooseItemsAction (data) {
      this.itemVisible = false
      if (data === null || data.length <= 0) return
      this.relItems = data
    },
    closeItemDialogAction () {
      this.itemVisible = false
    },
    deleteItemRow: function (index) {
      this.setItemStatus = false
      this.relItems.splice(index, 1)
    },
    relStoresClick(){
      this.storeVisible = true
      this.setStatus = true
    },
    chooseStoreAction (data) {
      this.storeVisible = false
      this.form.shop_ids = []
      if (data === null || data.length <= 0) return
      this.relStores = data
    },
    closeStoreDialogAction () {
      this.storeVisible = false
    },
    deleteStoreRow (index, ) {
      this.setStatus = false
      this.relStores.splice(index,1)
    },
    submitActivityAction () {
      const that = this
      if (this.activity_date.length > 0) {
        this.form.start_time = this.activity_date[0]/1000
        this.form.end_time = this.activity_date[1]/1000
      }

      if (this.conditionValue.length > 0) {
        this.conditionValue.forEach(rule => {
          if (rule.full==0 || !rule.full) {
            this.$message.error('加价购条件必填!')
            return
          }
        })
        this.form.condition_value = JSON.stringify(this.conditionValue)
      }
      if (this.validGrade.length > 0) {
        this.form.valid_grade = this.validGrade
      }

      this.form.shop_ids = []
      if (this.relStores && this.relStores.length > 0) {
          this.relStores.forEach( item => {
            this.form.shop_ids.push(item.distributor_id)
          })
      }

      this.form.item_ids = []
      if (this.relItems && this.relItems.length > 0) {
          this.relItems.forEach( item => {
            this.form.item_ids.push(item.itemId)
          })
      }

      if (this.purchaseRules.length > 0) {
        let giftData = []
        let itemdata = {}
        this.purchaseRules.forEach(rule => {
            if (rule.price > 0 && rule.gift_item.length == 0) {
                this.$message.error('加价购商品至少选一件!')
                return
            }
            rule.gift_item.forEach( item => {
              itemdata = {
                  item_id: item.itemId,
                  item_name: item.itemName,
                  item_type: item.item_type,
                  price: rule.price,
                  gift_num: item.gift_num,
                  pics: item.pics,
                  filter_ful: this.conditionValue[0].full
              }
              giftData.push(itemdata)
            })
        })
        this.form.gifts = JSON.stringify(giftData)
      }
      if (this.form.marketing_id) {
        updateMarketingActivity(this.form).then(res => {
          if(res.data.data.marketing_id){
            this.loading = false
            this.$message({
              message: '更新成功',
              type: 'success',
              duration: 2 * 1000,
              onClose () {
                that.refresh()
                that.$router.go(-1)
              }
            })
          } else {
            this.$message.error('保存失败!')
            return false
          }
        })
      } else {
        addMarketingActivity(this.form).then(res => {
          if(res.data.data.marketing_id){
            this.loading = false
            this.$message({
              message: '添加成功',
              type: 'success',
              duration: 2 * 1000,
              onClose () {
                that.refresh()
                that.$router.go(-1)
              }
            })
          } else {
            this.$message.error('保存失败!')
            return false
          }
        })
      }
    },
    getActivityDetail(id) {
      getMarketingActivityInfo({marketing_id:id}).then(res => {
        let response = res.data.data
        let data = {
          marketing_type: 'plus_price_buy',
          promotion_tag: '加价购',
          marketing_id: response.marketing_id,
          marketing_name: response.marketing_name,
          marketing_desc: response.marketing_desc,
          start_time: response.start_time,
          end_time: response.end_time,
          used_platform: response.used_platform,
          use_bound: response.use_bound,
          use_shop: response.use_shop,
          valid_grade: response.valid_grade,
          condition_type: response.condition_type,
          join_limit: response.join_limit,
          item_type: response.item_type,
          canjoin_repeat: response.canjoin_repeat,
        }
        this.form = data
        this.conditionValue = response.condition_value
        this.validGrade = response.valid_grade
        this.activity_date = [response.start_time*1000, response.end_time*1000]
        this.relItems = response.itemLists ? response.itemLists : []
        this.relStores = response.storeLists ? response.storeLists : []
        this.purchaseRules = response.gifts_item ? response.gifts_item : []
      })
    },
    handleCancel: function () {
      this.$router.back(-1)
    },
    relGiftsClick (index, itemArr) {
      if (!this.purchaseRules[index].price) {
        this.$message.error('加价金额必填!')
        return false
      }
      this.getParams.price = this.purchaseRules[index].price
      this.ruleKey = index
      this.relGiftIds = itemArr
      this.giftVisible = true
      this.setGiftStatus = true
    },
    chooseGiftsAction (data) {
      this.giftVisible = false
      if (data === null || data.length <= 0) return

      let arr = []
      data.forEach((item, index) => {
        item.gift_num = 1
      })
      let key = this.ruleKey
      this.purchaseRules[key].gift_item = data
    },
    closeGiftsDialogAction () {
      this.giftVisible = false
    },
    deleteGiftRow: function (key, index) {
      this.setGiftStatus = false
      this.purchaseRules[key].gift_item.splice(index, 1)
    },
  },
  mounted () {
    if (this.$route.params.marketing_id) {
      this.getActivityDetail(this.$route.params.marketing_id)
    }

    listVipGrade().then(response => {
      if(response != undefined && response.data.data && response.data.data.length >0) {
        this.vipGrade = response.data.data
      }
    })

    getGradeList().then(response => {
      if(response != undefined && response.data.data && response.data.data.length >0) {
        var result = response.data.data
        if(result) {
          this.memberGrade = result
        }
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// add.vue?6680b2d8